import User from '@/models/User';

export const optimizelyMixin = {
  methods: {
    $_isFeatureEnabled(feature = '') {
      const visitor = User.query().first();
      const username = visitor ? visitor.username : 'unauthenticated';
      const isAuthenticated = !!visitor;
      const user_id = visitor ? visitor.id.toString() : 'unauthenticated';

      const mc_id = this.$route?.params?.learningUnitId?.toString() || null;

      return isFeatureEnabled(this.$optimizelyClientInstance, feature, username, {
        isAuthenticated,
        user_id,
        mc_id
      });
    }
  }
};

export const isFeatureEnabled = (optimizely, feature, userId, attributes = {}) => {
  return optimizely.isFeatureEnabled(feature, userId, {
    ...attributes
  });
};
